/** Диплинки TG-кнопок (24.08, владелец): ?open_booking=&open_date=&open_client=1.
 *  Захватываются ДО роутинга (AuthGate редиректит на /{role} и стирает query —
 *  паттерн captureDevQueryParam) в sessionStorage; DcGridScreen забирает
 *  однократно: переключает день, открывает модалку брони и — при open_client —
 *  сразу карточку клиента. */
const KEY = "ub_deeplink";

export interface Deeplink { booking: number; date: string | null; client: boolean }

/** Захватить диплинк. Возвращает true, если он был: вызывающий по этому признаку
 *  открывает диспетчерскую сетку, где бронь и приземляется. */
export function captureDeeplink(): boolean {
  const p = new URLSearchParams(window.location.search);
  const booking = Number(p.get("open_booking"));
  if (!booking) return false;
  sessionStorage.setItem(KEY, JSON.stringify({ booking, date: p.get("open_date"), client: p.get("open_client") === "1" }));
  ["open_booking", "open_date", "open_client"].forEach((k) => p.delete(k));
  window.history.replaceState(null, "", window.location.pathname + (p.toString() ? `?${p}` : "") + window.location.hash);
  return true;
}

/** 28.09 (владелец: «Посмотреть» под сводкой админа зала — «сразу переходит в этот дашборд и
 *  видит, что будет в этот день»): ?op_day=ГГГГ-ММ-ДД — кабинет оператора на этом дне. */
const OP_DAY = "ub_op_day";
export function captureOpDay(): boolean {
  const p = new URLSearchParams(window.location.search);
  const day = p.get("op_day");
  if (!day || !/^\d{4}-\d{2}-\d{2}$/.test(day)) return false;
  sessionStorage.setItem(OP_DAY, day);
  p.delete("op_day");
  window.history.replaceState(null, "", window.location.pathname + (p.toString() ? `?${p}` : "") + window.location.hash);
  return true;
}
/** Забрать день (одноразово): «ГГГГ-ММ-ДД» или null. */
export function takeOpDay(): string | null {
  const d = sessionStorage.getItem(OP_DAY);
  if (d) sessionStorage.removeItem(OP_DAY);
  return d;
}

/** 13.10 (владелец: «заполни график» в Telegram): ?op_tab=sched — кабинет оператора сразу на вкладке «График». */
const OP_TAB = "ub_op_tab";
const OP_TABS = ["sched"];
export function captureOpTab(): boolean {
  const p = new URLSearchParams(window.location.search);
  const tab = p.get("op_tab");
  if (!tab || !OP_TABS.includes(tab)) return false;
  sessionStorage.setItem(OP_TAB, tab);
  p.delete("op_tab");
  window.history.replaceState(null, "", window.location.pathname + (p.toString() ? `?${p}` : "") + window.location.hash);
  return true;
}
/** Забрать вкладку (одноразово) или null. */
export function takeOpTab(): string | null {
  const t = sessionStorage.getItem(OP_TAB);
  if (t) sessionStorage.removeItem(OP_TAB);
  return t;
}

/** Забрать и погасить диплинк (одноразовый). */
export function takeDeeplink(): Deeplink | null {
  const raw = sessionStorage.getItem(KEY);
  if (!raw) return null;
  sessionStorage.removeItem(KEY);
  try { return JSON.parse(raw) as Deeplink; } catch { return null; }
}
